import {get} from 'lodash';

export default (state = {}, {clientId, alerts}: any) => {
  return {
    ...state,
    allAlertsData: {
      ...get(state, 'allAlertsData', {}),
      [clientId]: {
        ...alerts,
      },
    },
  };
};
